import React, { useState, useEffect } from "react";
import "./popup.css";

function Popup({ props, onDataSend }) {
  console.log("Popup Data:", props);
  const sendDataToParent = () => {
        onDataSend(false);
      };
  const renderContent = (item) => {
    switch (item.type) {
      case 'image':
        return <div className="image-container">
          <img src={item.image} alt="Popup Image" />
        </div>;
      case 'details':
        return <div dangerouslySetInnerHTML={{ __html: item.details }} />;
      case 'table':
        return <table className="table">
          <thead>
            <tr>
              {item.table.headers.map((header, ind) => (<th key={ind}>{header}</th>))}
            </tr>
          </thead>
          <tbody>
            {item.table.rows.map((row,ind) => (<tr key={ind}>
              {row.map((cell,ind) => (<td key={ind}>{cell}</td>))}
            </tr>))}
          </tbody>
        </table>;
      default:
        return '';
    }
  };

  
  return (
    <div
      className="modal"
      id="popupModal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="popupModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="popupModalLabel">
             {props.title || "Popup Title"}
            </h5>
            <button
              type="button"
              className="close"
              onClick={sendDataToParent}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <div className="row">
              <div className="col-md-6">
                {/* <h5>Left Column</h5> */}
                {
                    props.details.filter((item) => item.column === "left").map((item, index) => (
                      <div key={index}>
                       { renderContent(item)}
                   
                      </div>
                    ))
                } 
              </div>
              <div className="col-md-6">
                {/* <h5>Right Column</h5> */}
                 {
                    props.details.filter((item) => item.column === "right").map((item, index) => (
                      <div key={index}>
                       { renderContent(item)}
                      </div>
                    ))
                } 
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}


export default Popup;
